<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12>
                <v-text-field
                  label="报告题目"
                  :rules="rules.required"
                  v-model="item.title"/>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="报告人"
                  :rules="rules.required"
                  v-model="item.speaker"/>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="主办单位"
                  :rules="rules.required"
                  v-model="item.organizer"/>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="活动地点"
                  :rules="rules.required"
                  v-model="item.venue"/>
              </v-flex>

              <v-flex xs12 sm6>
                <v-menu
                  ref="refDate"
                  :close-on-content-click="false"
                  v-model="menuDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.date"
                    label="活动日期"
                    :rules="rules.date"
                    hint="格式YYYY-MM-DD, 如：2018-10-01"
                    persistent-hint
                  />
                  <v-date-picker
                    v-model="xdate"
                    locale="zh-cn"
                    @change="nv => item.date= nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs4>
                <v-menu
                  ref="refTime"
                  :close-on-content-click="false"
                  v-model="menuTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.time"
                    label="活动时间"
                    :rules="rules.time"
                    hint="格式HH:MM, 如 09:30"
                    persistent-hint
                  />
                  <v-time-picker
                    v-model="time"
                    format="24hr"
                    locale="zh-cn"
                    @change="nv => item.time= nv"
                  />
                </v-menu>

              </v-flex>


              <!--<v-flex xs4>-->
              <!--<v-menu-->
              <!--ref="refPubDate"-->
              <!--:close-on-content-click="false"-->
              <!--v-model="menuPubDate"-->
              <!--:return-value.sync="item.pubDate"-->
              <!--lazy-->
              <!--transition="scale-transition"-->
              <!--offset-y-->
              <!--full-width-->
              <!--max-width="290px"-->
              <!--&gt;-->
              <!--<v-text-field-->
              <!--slot="activator"-->
              <!--v-model="item.pubDate"-->
              <!--label="发布日期"-->
              <!--clearable-->
              <!--read-only-->
              <!--:rules="rules.pubDate"-->
              <!--/>-->
              <!--<v-date-picker-->
              <!--v-model="item.pubDate"-->
              <!--locale="zh-cn"-->
              <!--scrollable-->
              <!--&gt;-->
              <!--<v-spacer></v-spacer>-->
              <!--<v-btn flat color="primary" @click="menuPubDate = false">取消</v-btn>-->
              <!--<v-btn flat color="primary" @click="$refs.refPubDate.save(item.pubDate)">确定</v-btn>-->
              <!--</v-date-picker>-->
              <!--</v-menu>-->

              <!--</v-flex>-->

              <v-flex xs2>
                <v-autocomplete
                  label="草稿"
                  required
                  :rules="rules.draft"
                  v-model="item.draft"
                  :items="[{value: true, text:'是'}, {value: false, text:'否'}]"
                />
              </v-flex>

              <v-flex xs12>
                <x-single-uploader
                  label="海报图片"
                  :action="fileUri"
                  v-model="item.coverPhoto"
                  extensions="jpg,jpeg,png,gif"
                  accept="image/png,image/gif,image/jpeg"
                  :size="Number(2)"
                  hint="上传 jpg, jpeg, png 或 gif 图片，大小不超过 2M."
                >
                </x-single-uploader>
              </v-flex>

              <v-flex xs12>
                <ck-editor
                  v-model="item.content"
                  editor-id="report-editor"
                ></ck-editor>
              </v-flex>

              <v-flex xs12>
                <x-uploader
                  label="附件列表"
                  :action="fileUri"
                  v-model="item.attachments"
                  :size="Number(100)"
                  description="附件大小不超过 100M."
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import {mapGetters} from 'vuex'

  import mixin from '@/mixin'
  import CkEditor from '@/components/global/CkEditor'
  import XUploader from '@/components/global/Uploader'
  import XSingleUploader from '@/components/global/SingleUploader'

  const baseUri = '/api/web/article';
  const sectionUri = '/api/web/section';

  export default {
    mixins: [mixin.edit(baseUri)],
    components: {CkEditor, XUploader, XSingleUploader},
    data() {
      return {
        fileUri: '/api/web/file',

        formValid: false,

        item: {
          "content": "",
          "coverPhoto": null,
        },
        freshItem: {
          "sectionId": 'DpPXiJaAAAA',
          "title": null,
          "speaker": null,
          "venue": null,
          "date": null,
          "time": null,
          "organizer": null,
          "content": "",
          "pubDate": null,
          "draft": null,

          "coverPhoto": null
        },

        coverPhoto: false,

        menuDate: false,
        xdate: null,

        menuTime: false,
        time: null,

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'
          ],
          draft: [
            v => (v === true || v === false) || '必填项。'
          ],
          normal: [v => (!v || v.length <= 50) || '长度必须小于50个字符。'],

          date: [
            v => !!v || "必填项。",
            v => window.xutil.regexpDate().test(v) || '日期格式错误'
          ],

          time: [
            v => !!v || "必填项。",
            v => /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/ig.test(v) || '时间格式错误'
          ],
        },

        sectionLoading: false,
        sectionItems: [],
      }
    },

    created() {
      this.sectionLoading = true;
      this.axios.get(sectionUri, {params: {limit: 65535, sort: 'rank.asc'}})
        .then(
          rsp => {
            this.sectionLoading = false;
            this.sectionItems = rsp.data.items;

            this.item.pubDate = new Date().toISOString();
          })
    },

    computed: {
      ...mapGetters([
        'name'
      ])
    },

    methods: {
      beforeSendData(data) {
        window.console.log("beforeSendData");

        // const dt = new Date();
        // const ymd =this.item.date.split("-").map(v => Number(v));
        // dt.setFullYear(ymd[0], ymd[1] - 1, ymd[2]);
        //
        // const hm = this.item.time.split(":").map(v => Number(v));
        // dt.setHours(hm[0], hm[1], 0, 0);

        const dateTime = `${this.item.date}`.slice(0, 10);
        data.dateTime = `${dateTime}T${this.item.time}:00.000Z`;
      },
      afterGetData(data) {
        if (data.dateTime) {
          const dt = data.dateTime.split('T');
          data.date = dt[0];
          data.time = dt[1].substring(0, 5);
        }
      }
    }
  }
</script>
<style>
  .ck-content .image {
    clear: both;
    text-align: center;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .ck-content .image > figcaption {
    color: #333;
    background-color: #f7f7f7;
    padding: .6em;
    font-size: 1em;
    outline-offset: -1px;
  }
</style>
